import store from '@/store';
import { workEmailRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import callApi from '@/lib/helpers/call-api';

const getPayload = () => {
  const { values } = store.state.formData;
  const { appId } = store.state;
  const firstName = getValueByFieldName(values, FIELD_NAMES.firstName);
  const lastName = getValueByFieldName(values, FIELD_NAMES.lastName);
  var name = firstName + ' ' + lastName;
  return {
    "app-id": appId,
    "validation-type": "workemail",
    "name": name


  };
};

export default {
  async workEmailValidate(currentStep, callbacks) {
    const { form } = currentStep;
    let response = false;
    response = await callApi({
      callbacks,
      form,
      formElement: currentStep,
      apiCall: workEmailRepository.workEmailValidate,
      payload: getPayload(),
    });
  }
};
